// extracted by mini-css-extract-plugin
module.exports = {"loadingIndicator":"LoadingIndicator_loadingIndicator__2DUQK","loading":"LoadingIndicator_loading__ACSk3"};